import React from 'react';
import AmericanExpressIcon from '../../svg/AmericanExpressIcon';
import MasterCardIcon from '../../svg/MasterCardIcon';
import VisaIcon from '../../svg/VisaIcon';
import PayPalIcon from '../../svg/PaypalIcon';
import styled from '@emotion/styled';

const StyledFooterCopyright = styled.div`
	@media (max-width: 767px) {
		.drinkWiseLogo {
			margin-right: 0;
		}

		.payment svg:first-of-type {
			margin-left: 0 !important;
		}
	}
`;

function FooterCopyright({ brandData, enablePaypal, showCopyright }) {
	return (
		<StyledFooterCopyright className='footer-v2__copyright'>
			<div className='d-flex justify-content-between align-items-lg-start align-items-center flex-column-reverse flex-lg-row'>
				<div className='d-flex justify-content-start align-items-sm-start align-items-center flex-column flex-sm-row'>
					<div className='drinkWiseLogo'>
						{brandData?.country === 'AU' && (
							<a
								href='https://drinkwise.org.au/'
								target='_blank'
								rel='noreferrer'
							>
								<img
									src='/images/au/common/general/drinkWise_logo.png'
									alt='Choose to DrinkWise'
									title='Choose to DrinkWise'
									className='d-inline-block'
								/>
							</a>
						)}
						{brandData?.country === 'NZ' && (
							<a
								href='http://www.cheers.org.nz/'
								target='_blank'
								rel='noreferrer'
							>
								<img
									src='/images/au/common/general/cheers_logo.svg'
									alt='Cheers'
									title='Cheers'
									className='d-inline-block'
								/>
							</a>
						)}
					</div>
					{showCopyright && (
						<div className='copyright_v2 text_small text-dark-mdeium'>
							© {new Date().getFullYear()} {brandData?.legalName} | Tel:{' '}
							{brandData?.phoneRecr}. All rights reserved. You must be 18 years
							of age or over to order wine from this site. It is against the law
							to sell or supply alcohol to, or obtain alcohol on behalf of, a
							person under the age of 18.
						</div>
					)}
				</div>
				<div className='payment flex-shrink-0'>
					{enablePaypal && <PayPalIcon />}
					<MasterCardIcon className='ml-12' />
					<VisaIcon className='ml-12' />
					<AmericanExpressIcon className='ml-12' />
				</div>
			</div>
		</StyledFooterCopyright>
	);
}

export default FooterCopyright;
